import React, { createContext, useContext } from 'react';

import { mergePageContext, useNextActions } from './hooks/use_next_actions';

import type { Message, PageContext } from './types';

type NextActionsContextValue = ReturnType<typeof useNextActions>;

const NextActionsContext = createContext<NextActionsContextValue | null>(null);

export function useNextActionsContext() {
  const context = useContext(NextActionsContext);
  if (!context) {
    throw new Error('useNextActionsContext must be used within a NextActionsProvider');
  }

  return context;
}

export function NextActionsProvider({ children }: { children: React.ReactNode }) {
  const nextActions = useNextActions();

  return <NextActionsContext.Provider value={nextActions}>{children}</NextActionsContext.Provider>;
}

// The next-action half of what a surface reports
export function withNextActions(nextActions: NextActionsContextValue, page?: () => PageContext | null) {
  return (messages: Message[]) => mergePageContext(page?.() || null, nextActions.context(messages));
}
